import { Component, EventEmitter, forwardRef, OnDestroy, OnInit, Output, Input } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';

import { CompanyService } from 'src/app/_service/company.service';
import { VesselService } from 'src/app/_service/vessel.service';
import { UserService } from 'src/app/_service/user.service';
import { TenantService } from 'src/app/_service/tenant.service';
import { OpenWebUIService } from 'src/app/_service/open-web-ui.service';
import { TranslateService } from '@ngx-translate/core';
import { postUserData, userForm } from 'src/app/_model/user_data';
import { getCompanyData } from 'src/app/_model/company';
import { getVesselData } from 'src/app/_model/vessel';
import { getTenantData } from 'src/app/_model/tenant';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { USER_ROLES } from 'src/app/_model/string_literal';
 
@Component({
  selector: 'app-user-register',
  templateUrl: './user-register.component.html',
  styleUrls: ['./user-register.component.css'],
})

export class UserRegisterComponent implements OnInit, OnDestroy {
  @Output() dataChange = new EventEmitter();
  form = new userForm;
  userForm = this.form.defaultForm;
  editUserData!:postUserData;
  editMode = false;
  selectedVessel: any;
  selectedCompany: any;
  selectedRole: any;
  selectedTenant: any;
  userID = '';
  userData!: postUserData;
  isSubmitting = false;
  isGlobalAdmin = false;
  isRegisteringOWUUser = false;

  constructor(
    private location: Location,
    private userService: UserService,
    private companyService: CompanyService,
    private vesselService: VesselService,
    private tenantService: TenantService,
    private openWebUIService: OpenWebUIService,
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
    private translate: TranslateService,
    public router: Router,
  ) {
    this.companyList = this.companyService.companyList;

    this.filteredTenantList = [];
    this.filteredVesselList = [];

    this.iconRegistry.addSvgIcon(
      'company',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/company.svg')
    );
    this.iconRegistry.addSvgIcon(
      'zoomin',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/zoomin.svg')
    );
    this.iconRegistry.addSvgIcon(
      'zoom',
      sanitizer.bypassSecurityTrustResourceUrl('/assets/zoom.svg')
    );
  }

  companyList: getCompanyData[];
  filteredVesselList: getVesselData[];
  filteredTenantList: getTenantData[];
  roles = USER_ROLES;

  ngOnInit(): void {
    if(this.userService.editUserFlag){
      this.setEditUserData(this.userService.editUserData);
      this.addToTempdata(this.userService.editUserData)
      this.editMode = true;
    }else{
      this.editMode = false;
      //this.userForm.patchValue({types: []});
    }
  }
  tempdata!: postUserData;
  addToTempdata(data: postUserData){
    this.tempdata = {
      name: data!.name,
      first_name: data!.first_name,
      last_name: data!.last_name,
      pincode: data!.pincode,
      position: data!.position,
      address: data!.address,
      telephone: data!.telephone,
      fax: data!.fax,
      email: data!.email,
      thumbnailExtension: data!.thumbnailExtension,
      oid: data!.oid,
      company_id: data!.company_id,
      role_id: data!.role_id,
      tenant_id: data!.tenant_id,
      vessel_id: data!.vessel_id,
    };
  }
  ngOnDestroy(): void {
    this.userService.resetSelectedUserID();
    this.userService.resetEditUser();
    this.userForm.reset();
  }

  setEditUserData(editUserData: postUserData){
    this.userForm.patchValue(<any>editUserData);
  }

  onRoleChange(event: any) {
    this.isGlobalAdmin = event?.value?.id === 3 ? true : false;
  }

  onCompanyChange(event: any) {
    this.selectedTenant = null;
    this.selectedVessel = null;

    if (event?.value) {
      this.vesselService.getVesselByManagerId(event?.value?.id).subscribe({
        next: async(value:any) => {
          this.filteredVesselList = value;
        },
        error: (error) => {
          console.error('Error fetching vessels:', error);
        },
      });
      this.tenantService.getTenantByCompanyID(event?.value?.id).subscribe({
        next: async(value:any) => {
          this.filteredTenantList = value;
        },
        error: (error) => {
          console.error('Error fetching tenants:', error);
        },
      });
    } else {
      this.filteredVesselList = [];
      this.filteredTenantList = [];
    }
  }

  onTenantChange(event: any) {
  }

  onSubmit() {
    if (this.checkSubmit()) {
      //invite new user
      this.isSubmitting = true;
      this.userForm.patchValue({ company_id: this.selectedCompany?.id.toString(), role_id: this.selectedRole?.id });
      if (this.selectedTenant && !this.isGlobalAdmin) {
        this.userForm.patchValue({tenant_id: this.selectedTenant?.id.toString()});
      }
      if (this.selectedVessel) this.userForm.patchValue({vessel_id: this.selectedVessel?.id.toString()});

      if (this.isRegisteringOWUUser) {
        this.openWebUIService.registerOpenWebUIUser(this.userForm.value.email, this.userForm.value.name, this.userForm.value.company_id)
          .subscribe({
            next: (response: any) => {
              console.log(response);
            },
            error: (err) => {
              window.alert(this.translate.instant("kikuhoRegisterErr") + err?.error?.detail || "不明なエラーが発生しました。");
            },
            complete: () => {}
          });
      }

      this.userService.submitNewUser(this.userForm.value).subscribe({
        error: (err) => {
          window.alert(this.translate.instant("err"));
          this.isSubmitting = false;
        },
        complete: () => {
          this.isSubmitting = false;
          window.alert(this.translate.instant("created"));
          this.userForm.reset();
          this.location.back();
          this.dataChange.emit();
        }
      });
    }
  }

  checkSubmit() {
    if(window.confirm('Can I register this?')){
      return true;
    }else{
      return false;
    }
  }

  goBack(){
    this.location.back();
  }
}
